import React from 'react';
import { SearchMobileHeader } from './SearchMobileHeader';
import { DesktopType } from '../aside-filters/desktop-type/DesktopType';
import { AsideFilters } from '../aside-filters/AsideFilters';
import { SortList } from '../search-sort/sort-list/SortList';
import { Connect, PropsFromRedux } from './SearchAsideContainer';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { MobileFilters } from './MobileFilters';

type Props = PropsFromRedux;

export class RawSearchAside extends React.Component<Props> {
  onCloseFilters = (source: string) => () => {
    const { closeFilter } = this.props;
    doctrineAnalytics('Search FilterClosed', { source });
    closeFilter();
  };

  render() {
    const { showFilters, selectedFiltersLength, resetFilters } = this.props;
    return (
      <>
        <SearchMobileHeader
          closeFilter={this.onCloseFilters('cross')}
          resetFilters={resetFilters}
          selectedFiltersLength={selectedFiltersLength}
        />
        <div className="search-aside">
          <DesktopType />
          {showFilters && (
            <div className="search-aside__list">
              <MobileFilters />
              <SortList />
              <AsideFilters />
            </div>
          )}
        </div>

        <div
          onClick={this.onCloseFilters('backdrop')}
          className="search-aside__overlay"
        />
      </>
    );
  }
}

export const SearchAside = Connect(RawSearchAside);
